import { useState, useEffect } from 'react';

/**
 * useCharacterModals - Custom hook to manage all modal states for character sheet
 * @returns {object} All modal state variables and their setters
 */
const useCharacterModals = () => {
  // Core modal states
  const [isManagingCards, setIsManagingCards] = useState(false);
  const [isManagingInventory, setIsManagingInventory] = useState(false);
  const [activeInventoryTab, setActiveInventoryTab] = useState('equipment');
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);

  // Activity modal states
  const [isHarvesting, setIsHarvesting] = useState(false);
  const [isFeasting, setIsFeasting] = useState(false);
  const [showFeastOptions, setShowFeastOptions] = useState(false);
  const [isDowntiming, setIsDowntiming] = useState(false);
  const [isAtBerrysRestaurant, setIsAtBerrysRestaurant] = useState(false);
  const [isFacingDeath, setIsFacingDeath] = useState(false);
  const [isLootCollecting, setIsLootCollecting] = useState(false);
  const [isBrowsingEquipment, setIsBrowsingEquipment] = useState(false);
  const [activeFrameMechanic, setActiveFrameMechanic] = useState(null);

  // Other UI state
  const [selectedCard, setSelectedCard] = useState(null);
  const [activationMessage, setActivationMessage] = useState(null);
  const [openFeature, setOpenFeature] = useState(null);

  // Close settings dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSettingsDropdown && !event.target.closest('.relative')) {
        setShowSettingsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSettingsDropdown]);

  // Close feast options dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showFeastOptions && !event.target.closest('[data-feast-options]')) {
        setShowFeastOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFeastOptions]);

  // Helper function to toggle features
  const toggleFeature = (feature) => {
    setOpenFeature(openFeature === feature ? null : feature);
  };

  return {
    // Core modals
    isManagingCards,
    setIsManagingCards,
    isManagingInventory,
    setIsManagingInventory,
    activeInventoryTab,
    setActiveInventoryTab,
    showSettingsDropdown,
    setShowSettingsDropdown,

    // Activity modals
    isHarvesting,
    setIsHarvesting,
    isFeasting,
    setIsFeasting,
    showFeastOptions,
    setShowFeastOptions,
    isDowntiming,
    setIsDowntiming,
    isAtBerrysRestaurant,
    setIsAtBerrysRestaurant,
    isFacingDeath,
    setIsFacingDeath,
    isLootCollecting,
    setIsLootCollecting,
    isBrowsingEquipment,
    setIsBrowsingEquipment,
    activeFrameMechanic,
    setActiveFrameMechanic,

    // Other UI state
    selectedCard,
    setSelectedCard,
    activationMessage,
    setActivationMessage,
    openFeature,
    setOpenFeature,
    toggleFeature
  };
};

export default useCharacterModals;
